import { isEmpty } from 'lodash';

// constants
import { managementZonesTypes } from 'constants/scripts';

// selectors
import { getActiveFieldId } from 'current/selectors';
import { getPlantingScriptsForFieldId } from 'scripts/planting-selectors';

export const getPlantingManagementZones = (state) => {
  const scripts = getPlantingScriptsForFieldId(state, getActiveFieldId(state));
  if (isEmpty(scripts)) {
    return [];
  }

  const displayPrimaryScripts = Object.values(scripts);
  if (Object.keys(displayPrimaryScripts).length === 0) {
    return [];
  }
  return displayPrimaryScripts.map((script) => {
    const { id, 'cropping-year': year, primary,
      'update-time': lastUpdated } = script;
    return {
      id:  `${managementZonesTypes.PLANTING}-${year}-${id}`,
      lastUpdated,
      managementZonesType: managementZonesTypes.PLANTING,
      primary,
      productYear: year,
      scriptId: id,
      zones: script.zones
    };
  });
};
